import React from "react";
import { IdeiaDto } from "../../../../../../../shared/dto/IdeiaDto";
import DimensionProvider from "../../../../../../../shared/provider/DimensionProvider";
import { DimensionDto } from "../../../../../../../shared/dto/DimensionDto";
import RatingDimensionItems from "./ratingDimensionItems";
import { RatingDto } from "../../../../../../../shared/dto/RatingDto";
import { RatingPayload } from "../../..";

interface RatingCriteriasItemsProps {
  idea: IdeiaDto;
  ratingPayload: RatingPayload;
  setRatingPayload: (value: RatingPayload) => void;
  rating: RatingDto;
  setIsRatingChanged: (value: boolean) => void;
}

function RatingCriteriasItems({ idea, ratingPayload, setRatingPayload, rating, setIsRatingChanged }: RatingCriteriasItemsProps): JSX.Element {
  const [dimensions, setDimensions] = React.useState<DimensionDto[]>([]);

  const dimensionProvider = new DimensionProvider();

  async function getDimensions() {
    try {
      const response = await dimensionProvider.getAll({ page: 1, itemsPerPage: 500 });
      setDimensions(response.data);
    } catch (error) {
      console.error("Erro ao buscar dimensões:", error);
    }
  }

  async function onInit() {
    await getDimensions();
  }

  React.useEffect(() => {
    onInit();
  }, []);

  return (
    <div>
        <RatingDimensionItems dimensions={dimensions} ratingPayload={ratingPayload} setRatingPayload={setRatingPayload} rating={rating} idea={idea} setIsRatingChanged={setIsRatingChanged} />  
    </div>
  );
}

export default RatingCriteriasItems;